module.exports = __webpack_public_path__ + "img/form.02998845.svg";